const $ = require('jquery');

module.exports = function (inspirationService, $timeout, $location, $anchorScroll, $state, $rootScope, breakpointsService, featureService) {
    return {
        restrict: 'E',
        link(scope) {
            scope.openCategories = {};
            const leftPanelScroller = $('#left-panel .hideScroll-wrapper');

            function _init() {
                //when discover link on LF banner clicked - open first item in list
                if ($state.is('shop.inspiration') && !scope.isSmallFormat) {
                    scope.isEnableDiscoverLandingPage = featureService.isEnabled(featureService.features.enableDiscoverLandingPage);
                    if (!scope.isEnableDiscoverLandingPage) {
                        $state.go('shop.inspiration.parent', { parent: scope.menuItems[0].UrlPart });
                    }
                }

                if (scope.isSmallFormat) {
                    leftPanelScroller.find('.inspirationNavigationContainer').css({
                        'padding-bottom': Math.round(leftPanelScroller.height() / 1.10)
                    });
                }
            }

            scope.isSmallFormat = breakpointsService.isSmallFormat();
            scope.$on('window:resize', function () {
                // check whether a resize makes the screen small Format
                scope.$apply(function () {
                    scope.isSmallFormat = breakpointsService.isSmallFormat();
                });
            });

            inspirationService.getNavigationItems().then(function (response) {
                // Return the left panel Navigation Items and if not small format, open the first on the list
                scope.menuItems = response;
                _init();
            });

            function isOpen(urlPart) {
                const sourcePath = $location.path().split('/');
                const urlPath = sourcePath[sourcePath.length - 1];
                return (urlPath === urlPart);
            }

            scope.showSmallFormatChildren = function (childUrl) {
                return scope.isSmallFormat && isOpen(childUrl);
            };

            //Have to use functions for parent and child clicked to handle small format scrolling.
            scope.parentClicked = function () {
                if (scope.isSmallFormat) {
                    $(leftPanelScroller).animate({ scrollTop: 0 }, 'fast');
                }
            };

            scope.childClicked = function (child) {
                if (scope.isSmallFormat) {
                    $location.hash(`inspirationChildPage-${child.ID}`);
                    $anchorScroll();
                }
            };

            // Returns a css class that shows which page is currently active
            // If urlPart is last in the sourcePath, show gray banner styling (only-active)
            // If urlPart is anywhere else in string, show is-active (shows children)
            scope.isActive = function (urlPart) {
                const sourcePath = $location.path().split('/');
                if (isOpen(urlPart)) {
                    return 'is-only-active';
                } else if (sourcePath.indexOf(urlPart) > -1) {
                    return 'is-active';
                }
            };

            $rootScope.$on('$stateChangeSuccess',
                _init
            );
        },
        template: require('./inspiration-navigation-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/inspiration-navigation-directive.js
 **/